import { putStockRule } from '../../services/api/stockRule.api';
import { PUT_STOCK_RULE_REQUEST, PUT_STOCK_RULE_SUCCESS, PUT_STOCK_RULE_FAILURE } from '../types';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
	},

	mutations: {
		[PUT_STOCK_RULE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[PUT_STOCK_RULE_SUCCESS](state) {
			state.isLoading = false;
		},
		[PUT_STOCK_RULE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async updateStockRule({ commit }, { id, params }) {
			try {
				commit(PUT_STOCK_RULE_REQUEST);
				await putStockRule(id, params);
				commit(PUT_STOCK_RULE_SUCCESS);
			} catch (error) {
				commit(PUT_STOCK_RULE_FAILURE, error);
			}
		},
	},
};